import CardActions from '@mui/material/CardActions';
import useCreditPrice from '../../../../hooks/useCreditPrice';
import CreditsPrice from '../../../MyApps/components/CreditsPrice';
import PurchaseButton from '../../../MyApps/components/PurchaseButton';
import FeaturesList from '../FeaturesList';
import { Feature } from '../FeaturesList/FeaturesList';
import { StyledCard, StyledCardContent, StyledCardHeader } from './styled';

const FEATURES_LIST: Feature[] = [
  {
    label: 'Track credits never expire',
  },
  {
    label: 'Top-up anytime',
  },
  {
    label: 'Super-fast music generation',
  },
  {
    label: 'Access all core models',
  },
  {
    label: 'Text-to-music',
  },
  {
    label: 'Music Generator',
  },
  {
    excluded: true,
    label: 'Music Catalog',
  },
  {
    excluded: true,
    label: 'Sub-license',
  },
];

const PurchaseCredits = () => {
  const price = useCreditPrice();

  if (price === null) {
    return null;
  }

  return (
    <StyledCard>
      <StyledCardHeader
        title="Pay As You Go"
        subheader="Purchase track credits that never expire. Perfect for occasional use or getting started."
      />
      <StyledCardContent>
        <CreditsPrice
          pricePerCredit={price.priceCents}
          labels={{
            totalUnits: 'Total track generations',
            costPerUnit: 'Cost per track generation',
            total: 'One-off payment',
          }}
        />
        <FeaturesList features={FEATURES_LIST} />
      </StyledCardContent>
      <CardActions>
        <PurchaseButton />
      </CardActions>
    </StyledCard>
  );
};
export default PurchaseCredits;
